import { ArrowUpRight, Building2, Droplets, Hammer, House, Layers3, Paintbrush, ShieldCheck, Zap } from "lucide-react";
import { Link } from "react-router-dom";
import { ResponsiveImage } from "@/components/ResponsiveImage";

const icons = { hammer: Hammer, droplets: Droplets, zap: Zap, paintbrush: Paintbrush, house: House, layers: Layers3, shield: ShieldCheck, building: Building2 };

export const ServiceCard = ({ service, compact = false }) => {
  const Icon = icons[service.icon] || Hammer;
  return (
    <article className={`service-card tone-${service.tone} ${compact ? "service-card-compact" : ""}`} data-testid={`service-card-${service.slug}`}>
      <Link to={`/services/${service.slug}`} className="service-image-link" data-testid={`service-image-link-${service.slug}`} aria-label={`Read about ${service.title}`}>
        <ResponsiveImage slug={service.image} alt={service.title} sizes={compact ? "(max-width: 760px) 100vw, 25vw" : "(max-width: 760px) 100vw, 50vw"} testId={`service-image-${service.slug}`} />
        <span>{service.supplied ? "Suha Builders work" : "Service reference"}</span>
      </Link>
      <div className="service-card-copy">
        <div className="service-card-code"><span>{service.code}</span><Icon size={20} /></div>
        <h3><Link to={`/services/${service.slug}`} data-testid={`service-title-link-${service.slug}`}>{service.title}</Link></h3>
        <p>{service.short}</p>
        {!compact && <ul>{service.tasks.map((task) => <li key={task}>{task}</li>)}</ul>}
        <Link to={`/services/${service.slug}`} className="text-link" data-testid={`service-read-more-${service.slug}`}>View service <ArrowUpRight size={16} /></Link>
      </div>
    </article>
  );
};
